import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Typography, units } from '@hbf/dsl';
import { ValuePropositionData } from './types';
import { VpCompact } from './VpCompact';

const useStyles = makeStyles()(theme => ({
  overflowHidden: {
    overflow: 'hidden',
  },
  container: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
  },
  title: {
    marginBottom: units.rem(1.5),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(2.5),
    },
  },
}));

export interface Props {
  valuePropositions: ValuePropositionData[];
  title: string;
}

export const VpDouble: React.FC<Props> = ({ valuePropositions, title }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.overflowHidden}>
      <Typography.H1 className={classes.title} component="h3" align="center">
        {title}
      </Typography.H1>
      <Grid
        container
        className={classes.container}
        spacing={5}
        justifyContent="space-between"
      >
        {valuePropositions.map(vp => (
          <Grid item xs={12} md={6} key={vp.title}>
            <VpCompact valueProposition={vp} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
